import { Skeleton, Stack } from '@chakra-ui/react'
import { range } from 'lodash-es'

import { NOTIFICATION_ITEM_HEIGHT } from './constants'

const SKELETON_COUNT = 20
export default function NotificationsLoading(): JSX.Element {
  return (
    <Stack direction="column" align="center" spacing="8px" width="100%">
      {range(SKELETON_COUNT).map(i => (
        <Skeleton
          height={NOTIFICATION_ITEM_HEIGHT}
          key={i}
          width="100%"
          borderRadius="8px"
          startColor="bg.subtle"
          endColor="bg.emphasized"
        />
      ))}
    </Stack>
  )
}
